<template>
  <div>

    <!-- 发货唛头打印 -->
    <div class="label" v-for="(labelData, labelIndex) in prinData" :key="labelIndex" style="page-break-after:always;">
      <div class="head">
        <div class="time">打印日期：{{ getDate() }}</div>
        <div class=" head-item"><span v-if="labelData.order_detail_tag.type == 'FBA'">{{
          labelData.order_detail_tag.no }}</span> 发货数：{{ labelData.num }}</div>
        <div class="head-item" style="height: 70px; line-height: 70px;"> <span>购入数：{{ labelData.confirm_num
            }}</span>
          <b class="type">{{ labelData.order_detail_tag.type_translate }}</b>
        </div>
      </div>
      <div class="center">
        <div class="left" :class="{ FBA: labelData.order_detail_tag.type === 'FBA' }">
          {{ labelData.type }}
        </div>
        <div class="right">{{ labelData.sorting }}番</div>
      </div>
      <div class="content">

        <div class="row">
          <div class="lab">配货员：</div>
          <div class="val">{{ labelData.p_name }}</div>
        </div>
        <div class="row">
          <div class="lab">业务员：</div>
          <div class="val">{{ labelData.y_name }}</div>
        </div>
        <div class="row">
          <div class="lab">采购员：</div>
          <div class="val">{{ labelData.g_name }}</div>
        </div>
        <div class="row">
          <div class="lab">订单号：</div>
          <div class="val">{{ labelData.order_sn }}</div>
        </div>
        <div class="row">
          <div class="lab">商品番号：</div>
          <div class="val">{{ labelData.sorting }}</div>
        </div>
        <div class="row" style="height: 120px;">
          <div class="lab">商品属性：</div>
          <div class="val"><span v-for="(item, index) in labelData.detail_y" :key="index">{{ item.key }}:{{
            item.value
              }}</span></div>
        </div>
        <div class="row">
          <div class="lab">交易号：</div>
          <div class="val">{{ labelData.purchase_no }}</div>
        </div>
        <!-- 二维码 -->
        <div class="tiaoxingma">
          <canvas :id="'express_no' + (labelIndex + 1)" style="height:180px; width:100% ;" />
        </div>
        <div class="row" style="margin-bottom: 0px;">
          <div class="lab">物流号：</div>
          <div class="val" v-for="(item, index) in labelData.order_purchase_express" :key="index">{{ item.express_no }},
          </div>
        </div>
        <!-- <div class="row" >
        <div class="lab">检品单号：</div>
        <div class="val">张三</div>
      </div> -->
      </div>
    </div>
  </div>
</template>
<script>
import { getDate } from '@/utlis/date'
export default {
  props: {
    prinData: { type: Array, default: () => [] },
  },
  data() {
    return {
      getDate,
      dialogVisible: false,
    }
  },
  mounted() {
    this.prinData.forEach((item, index) => {
      this.getJsBarcode("#express_no" + (index + 1), item.purchase_no);
    })
  },
  methods: {
    // 一维码
    getJsBarcode(selector, data) {
      JsBarcode(selector, data, {
        displayValue: true,
        height: 180,
        width: 6,
        margin: 0,
        fontSize: 0,
        displayValue: false,
        lineColor: "#000000",//设置条和文本的颜色。
      });
      this.$forceUpdate();
    },

  },
}
</script>
<style scoped>
.label {
  margin: 40px;
  width: 1080px;
  height: 1600px;
  border: 1px solid #000;

  color: #000;

  .head {
    padding: 48px;
    position: relative;

    .time {
      font-size: 32px;
    }

    .head-item {
      font-size: 48px;
      margin-top: 40px;
      line-height: 48px;

      span {
        width: 400px;
        display: inline-block;
        margin-right: 40px;
      }

      .type {
        font-size: 70px;
        font-weight: bold;

      }
    }

  }

  .center {
    display: flex;
    font-size: 65px;
    font-weight: bold;
    border-top: 1px solid #000;
    border-bottom: 1px solid #000;
    text-align: center;
    font-weight: bold;

    div {
      padding: 35px 0;
      height: 48px;

    }

    .left {
      width: 700px;
      border-right: 1px solid #000;
    }

    .FBA {
      background-color: #000;
      color: #fff;
    }

    .right {
      flex: 1;
    }
  }

  .content {
    padding: 48px;

    .row {
      display: flex;
      margin-bottom: 50px;
      font-size: 36px;
      height: 40px;
      line-height: 40px;

      .lab {
        width: 240px;
      }

      .val {
        flex: 1;

      }
    }
  }

  .tiaoxingma {
    height: 160px;
    margin: 48px 0;
    overflow: hidden;
  }

  .isNeedRemove {
    height: 160px !important;

  }

}

.input {
  display: flex;
  padding: 0 30px;

  .lab {
    width: 80px;
    margin-right: 10px;
    line-height: 40px;
  }
}
</style>
